<ng-container *transloco="let t; prefix: 'experience'">
  <div class="details-title">
    <section class="details">
      @if (category()) {
        <h2 class="heading-s" data-cy="experience-category">
          <strong>{{ category() }}</strong>
        </h2>
      }
      @if (neighborhood()) {
        <h3 class="heading-s" data-cy="experience-neighborhood">{{ neighborhood() }}</h3>
      }
      @if (city()) {
        <h3 class="heading-s" data-cy="experience-city">{{ city() }}</h3>
      }
      @if (benefits()) {
        <ess-tag [tag]="benefitsTag" />
      }
    </section>
    <section class="title">
      <h1 class="heading-title" #titleElement data-cy="experience-title">{{ title() }}</h1>
    </section>
  </div>
</ng-container>
